export const CounterState = (state) => state.counter

export const countSelector = (state) => CounterState(state).count
export const isIncrementingSelector = (state) => CounterState(state).isIncrementing
export const isDecrementingSelector = (state) => CounterState(state).isDecrementing


export default {
  countSelector,
  isIncrementingSelector,
  isDecrementingSelector
}



// WEBPACK FOOTER //
// ./src/redux-modules/counter/CounterSelectors.js